var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNightDrivingEvent = function SvgNightDrivingEvent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4334 20C9.03337 20 7.72104 19.7333 6.49637 19.2C5.27171 18.6667 4.20504 17.946 3.29637 17.038C2.38771 16.13 1.66671 15.0633 1.13337 13.838C0.600041 12.6127 0.333374 11.3 0.333374 9.9C0.333374 7.46667 1.10837 5.321 2.65837 3.463C4.20837 1.605 6.18337 0.450667 8.58337 0C8.28337 1.65 8.37504 3.26267 8.85837 4.838C9.34171 6.41333 10.175 7.79233 11.3584 8.975C12.5417 10.1577 13.921 10.991 15.4964 11.475C17.0717 11.959 18.684 12.0507 20.3334 11.75C19.9 14.15 18.75 16.125 16.8834 17.675C15.0167 19.225 12.8667 20 10.4334 20Z",
    fill: "#696593"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNightDrivingEvent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "NightDrivingEvent.1ea59481bf5920c1bc5973a3d7ef2eeb.svg";